import { GQLIdEncoder } from '../../common/utils/GQLIdEncoder';
import { Slot } from '../models/Slot';
import { SlotType } from '../models/SlotType';

export class SlotMapper {
  readonly gqlIdEncoder = new GQLIdEncoder();

  mapGQLModel(data: any): Slot {
    // If a slot was created with a certain traceType, then that traceType must have been among the allowed ones
    const slotType = new SlotType(data.traceType, true);
    // optional values in API
    const tracesTotalCount = data.traces?.totalCount ?? 0;
    const reportsTotalCount = data.reports?.totalCount ?? 0;
    const projectMaxItem = data.project?.maxItemCount ?? 0;
    const atCapacity = Math.max(tracesTotalCount, reportsTotalCount) >= projectMaxItem;
    return new Slot(this.gqlIdEncoder.decode(data.id), data.name, data.description || null, slotType, data.tags || [], atCapacity);
  }
}
